import React, { Component, ReactNode } from 'react';
import MenuItemsLoader from '../loading/menuLoader';
import { clearAppStorage } from '../../utils/clearAppStorage';

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
    errorInfo: React.ErrorInfo | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
        // Update state so the next render will show the fallback UI
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        // Log error details
        console.error('ErrorBoundary caught an error:', error, errorInfo);

        this.setState({
            error,
            errorInfo
        });

        // Clear app-specific localStorage (preserve MSAL cache)
        try {
            clearAppStorage();
            console.log('localStorage cleared');
        } catch (e) {
            console.error('Failed to clear localStorage:', e);
        }

        // Logout user
        this.handleLogout();
    }

    handleLogout = async (): Promise<void> => {
        window.location.href = '/';
    };

    render(): ReactNode {
        if (this.state.hasError) {
            return <MenuItemsLoader />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
